/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {
    LINK_COPY: 'Kopieren'
  },
  ERROR: {},
  HEADER: {
    NAME: 'Name'
  },
  LABEL: {
    FILTER_MONTH_APR: 'April',
    FILTER_MONTH_AUG: 'August',
    FILTER_MONTH_DEC: 'Dezember',
    FILTER_MONTH_FEB: 'Februar',
    FILTER_MONTH_JAN: 'Januar',
    FILTER_MONTH_JUL: 'Juli',
    FILTER_MONTH_JUN: 'Juni',
    FILTER_MONTH_MAR: 'März',
    FILTER_MONTH_MAY: 'Mai',
    FILTER_MONTH_NOV: 'November',
    FILTER_MONTH_OCT: 'Oktober',
    FILTER_MONTH_SEP: 'September',
    GENERATE_HASHTAG: 'Hashtag generieren',
    GENERATE_LINK: 'Link generieren',
    GENERATED_HASHTAG: 'Generierter hashtag',
    GENERATED_LINK: 'Generierter Link',
    MONTH: 'Monat',
    NAME: 'Name',
    YEAR: 'Jahr'
  },
  SENTENCE: {
    NO_ROWS_PRODUCTS: 'Keine produkte',
    NO_ROWS_PRODUCTS_DESCRIPTION: 'Bitte ändere deine Suchkriterien'
  },
  SUCCESS: {
    HASHTAG_COPIED: 'Hashtag kopiert',
    LINK_COPIED: 'Link kopiert'
  },
  TOOLTIP: {
    MONTH: 'Monat',
    NAME: 'Name',
    YEAR: 'Jahr'
  }
};
